import { useCallback, useEffect, useRef, useState } from "react";
import { adminDiscussionDetails, banUser } from "../../services/communityService";
import { AdminDiscussDetailModel } from "./models/AdminDiscussDetailModel";
import { CommunityAdminBanType } from "../../pages/communityAdmin/enums/CommunityAdminBanType";

export const useAdminDetails = (id?: number | string) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState<AdminDiscussDetailModel | null>(null);
    const [error, setError] = useState<Error | boolean | null>(null);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        if(!id)
            return;
        try {
            setLoading(true);
            setDetails(null);
            setError(null);
            const _details = await adminDiscussionDetails(id);
            if(!isMountedRef.current)
                return;
            if(_details)
                setDetails(_details);
        }
        catch(err) {
            setError(err as Error ?? true);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);        
        }
    }, [id]);

    

    useEffect(() => {
        load();
    }, [load]);
    
    return { loading, details, error }
}